import { IComboBox, IComboBoxOption, Panel, PanelType } from '@fluentui/react';
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { PanelHeader } from '../../../../components/Panel/PanelHeader';
import { PanelFooter } from '../../../../components/Panel/PanelFooter';
import { MensajeBar } from '../../../../components/generic/ManejoResponseMessage/MessageBar';
import IdicadorProgress from '../../../../components/generic/IndicadorProgress';
import { ComboBoxIDS } from '../../../../components/generic/ComboBoxIDS';
import { IFilterEquipoModelo } from '../../../../Interfaces/IEquipo';
import listaVerificacionServicio from '../../../../services/ListaVerificacion/listaVerificacionServicio';
import { IPersonaEquipo } from '../../../../Interfaces/IListaVerificacion';
import { IResponsePost } from '../../../../Interfaces/base/IResponse';

export const PanelAgregarEquipoModelo = (props: any) => {
    const [objRegistrar, setObjRegistrar] = useState<IPersonaEquipo>({
        personaId: props.personaId,
        equipoModeloId: []
    });
    const [selectedKeys, setSelectedKeys] = useState<string[]>([]);

    const [personaId, setPersonaId] = useState("");


    //     useComboModeloEquipos inicio
    const [responseDelete, setResponseDelete] = useState<IResponsePost>(null!);


    const [equipoModeloCombo, setEquipoModeloCombo] = useState<IComboBoxOption[]>(
        []
    );




    const [dataRequest, setDataRequest] = useState<IFilterEquipoModelo>({
        search: "",
    });
    const comboBoxRefModeloEquipos = useRef<IComboBox>(null);

    const onClickComboModeloEquipos = () =>
        comboBoxRefModeloEquipos.current?.focus(true);

    const _openOptionModeloEquipos = useCallback(
        () => comboBoxRefModeloEquipos.current?.focus(true),
        []
    );

    const _onkeyUpSearchModeloEquipo = (
        event: React.KeyboardEvent<IComboBox>
    ) => {
        _openOptionModeloEquipos();
        let { value } = event?.target as HTMLInputElement;
        setDataRequest({ ...dataRequest, search: value });
    };

    const postComboEquipoModelo = (data: IFilterEquipoModelo) => {
        listaVerificacionServicio.EquipoModeloCombo(data).then((res) => {
            if (res.status === 200) {
                setEquipoModeloCombo(res.data);
            }
        });
    };





    // useEffect(() => {
    //     getDataPersonaEquipo();
    // }, []);


    //  useComboModeloEquipos fin


    const [response, setResponse] = useState<IResponsePost>(null!);
    const [isSend, setIsSend] = useState(false);
    // const agregarModeloEquipoPersona = (data: IPersonaEquipo) => {
    const agregarModeloEquipoPersona = () => {
        //setIsSend(true);
        listaVerificacionServicio
            .postPersonaEquipo(objRegistrar)
            .then((res) => {
                if (res.status === 200) {
                    setResponse(res.data.response);
                    //getData();
                    props.onRenderTable()
                    setIsSend(false);
                    setTimeout(() => {
                        setObjRegistrar(
                            {
                                ...objRegistrar,
                                equipoModeloId: []
                            }
                        )
                        setDataRequest({ ...dataRequest, search: "" })
                        props.onDismiss()
                    }, 2000);


                } else {
                    setIsSend(false);
                }
            })
            .catch((err) => {
                setIsSend(false);
            });
    };



    const _onChangEquipo = (
        event: React.FormEvent<IComboBox>,
        option?: IComboBoxOption
    ) => {
        if (event !== undefined) {
            if (option) {
                let data = (prevSelectedKeys: any[]) =>
                    option.selected
                        ? [...prevSelectedKeys, option!.key as string]
                        : prevSelectedKeys.filter((k) => k !== option!.key);
                setSelectedKeys(data);
            }
        }
    };

    const onRenderHeader = useCallback(
        () => (
            <>
                <PanelHeader
                    nameIconHeader="Add"
                    subTextHeader="Administracion Modelo Equipos"
                    textHeader="Modelos de equipos"
                />
            </>
        ),
        []
    );
    const onRenderFooter = useCallback(
        () => (
            <>
                <PanelFooter
                    texto="Agregar"
                    texto2={"Salir"}
                    onClick={() => {
                        // agregarModeloEquipoPersona(objRegistrar);
                        agregarModeloEquipoPersona();
                    }}
                    onDismiss={() => {
                        setDataRequest({ ...dataRequest, search: "" })
                        props.onDismiss();
                    }}
                />
            </>
        ),
        // [props.onDismiss, agregarModeloEquipoPersona, objRegistrar]
        [props.onDismiss, agregarModeloEquipoPersona]
    );

    useEffect(() => {
        // if (props.personaId) {
        //     setObjRegistrar({
        //         personaId: props.personaId,
        //         equipoModeloId: selectedKeys,
        //     });
        // }
        setObjRegistrar(
            {
                ...objRegistrar,
                personaId: personaId,
                equipoModeloId: selectedKeys
            }
        )

    }, [selectedKeys]);

    const LimpiarResponse = () => {
        setResponse(null!);
    };

    useEffect(() => {
        if (!props.isOpen) {
            // setObjRegistrar(null!);
            setObjRegistrar(
                {
                    ...objRegistrar,
                    equipoModeloId: []
                }
            )
            setSelectedKeys([]);
            LimpiarResponse();
        }
        setPersonaId(props.personaId)

    }, [props.isOpen]);

    useEffect(() => {
        if (props.isOpen) {
            postComboEquipoModelo(dataRequest);
        }
    }, [dataRequest, props.isOpen]);

    return (
        <Panel
            isOpen={props.isOpen}
            onDismiss={props.onDismiss}
            onRenderHeader={onRenderHeader}
            onRenderFooter={onRenderFooter}
            type={PanelType.custom}
            customWidth="400px"
            isFooterAtBottom={true}
        >
            <>
                {/* <h3 style={{ color: 'red' }}>PANELLLLLL</h3>
                <pre>{JSON.stringify("--------Exist Data select---", null, 2)}</pre>
                <pre>{JSON.stringify(selectedKeys, null, 2)}</pre>
                <pre>{JSON.stringify(objRegistrar, null, 2)}</pre> */}
                <br />
                <MensajeBar ocultar={() => LimpiarResponse()} response={response} />
                <IdicadorProgress subText="Registrando Datos" isSend={isSend} />
                <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-lg12">
                            <ComboBoxIDS
                                title="Modelos de Equipos:"
                                componentRef={comboBoxRefModeloEquipos}
                                KeyUp={_onkeyUpSearchModeloEquipo}
                                onClick={onClickComboModeloEquipos}
                                options={equipoModeloCombo}
                                useComboBoxAsMenuWidth
                                multiSelect
                                onChange={_onChangEquipo}
                            />
                        </div>
                    </div>
                </div>
                {/*  <pre>{JSON.stringify(objRegistrar, null, 2)}</pre> */}
            </>
        </Panel>
    );
};

